import { useServicesStore } from '../services.store';

export const useSaveServiceResponse = () => {
	return useServicesStore((state) => state.saveServiceResponse);
};
